
import { Vue, Component, Prop } from 'vue-property-decorator';

import ModalContent from '@/components/modal/ModalContent.vue';
import ModalFullScreen from '@/components/modal/ModalFullScreenNew.vue';

@Component({
	components: {
		ModalContent,
		ModalFullScreen,
	},
})
export default class SubmitTimeModal extends Vue {
	@Prop({ type: String, required: true }) rejectionReason!: String;

	closeModal(): void {
		this.$emit('close');
	}
}
